import React from 'react'
function LeftSection({imageURL,productName,productDescription,tryDemo,learnMore,googlePlay,appStore}) {
    return (
        <div className='container mt-5 '>
            <div className='row'>
                <div className='col'>
                    <img src={imageURL} alt={productName}
                    style={{width:"90%"}}/>
                </div>
                
                <div className='col mt-3'>
                    <h1>{productName}</h1>
                    <p className=' mt-4 text-muted'>{productDescription}</p>
                    <a  href={tryDemo} >Try Demo <i class="fa-solid fa-arrow-right-long"></i></a>
                    
                    <a className='mx-4'  href={learnMore}>Learn More <i class="fa-solid fa-arrow-right-long"></i></a>
                    <br />
                    <div className="mt-5">
                    <a  className='mx-3' href={googlePlay} ><img src=' media/images/googlePlayBadge.svg'></img>   </a>
                    
                    <a className='mx-3' href={appStore} ><img src='media/images/googlePlayBadge.svg'></img>    </a>
                    </div>
                </div>
            </div>
        </div>
     );
}

export default LeftSection;